export default "__VITE_PUBLIC_ASSET__2a6e3e3e__"